export const visualizeDFS = async (
  graph,
  setTraversedNode,
  setVisitedNodes,
  setStackNodes,
  setBacktrackingNode,
  controller
) => {
  const order = [];
  const visited = [];
  const stack = [];

  // Helper function to wait while paused
  const waitIfPaused = async () => {
    if (controller && controller.isPaused) {
      // Create a promise that will be resolved when resume is called
      await new Promise((resolve) => {
        controller.resolvePromise = resolve;
      });
    }
  };

  // Helper function to wait for a specified time
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const dfs = async (node) => {
    if (!node || visited.includes(node)) return;

    // Wait if paused before processing this node
    await waitIfPaused();

    // Mark as traversed and update UI
    setTraversedNode(node);
    visited.push(node);
    order.push(node);
    setVisitedNodes([...visited]);

    // Simulate a delay to visualize the traversal
    await wait(800);

    // Process each neighbor
    for (const neighbor of graph[node] || []) {
      if (!visited.includes(neighbor)) {
        // Add to stack and update UI
        stack.push(neighbor);
        setStackNodes([...stack]);

        // Wait if paused before going deeper
        await waitIfPaused();

        // Recursively process the neighbor
        await dfs(neighbor);

        // Wait if paused before backtracking
        await waitIfPaused();

        // Visualize backtracking
        setBacktrackingNode(node);
        await wait(500);
        setBacktrackingNode("");

        // Remove from stack after processing
        stack.pop();
        setStackNodes([...stack]);
      }
    }
  };

  // Start with the first node (the root)
  const startNode = Object.keys(graph)[0];
  if (startNode) {
    stack.push(startNode);
    setStackNodes([...stack]);
    await dfs(startNode);
  }

  // Clear the traversed node after traversal
  setTraversedNode("");
  setBacktrackingNode("");

  return order;
};
